export class FaqItemModel {
  system: string;
  question: string;
  answer: string;
  id?: number;

  questionEn: string;
  answerEn: string;
}
